<script lang="ts">
    import { useLocation, useNavigate } from "svelte-navigator";
    import { appManager } from "../AppManager";

    async function logout() {
        // this is only used in local dev, redirect to root.
        window.location.href = `${appManager.RootUrl}`;
    }
</script>

{#await logout()}
    <div />
{/await}
